const o = /* @__PURE__ */ new Set();
function a(r, e) {
  const n = `[naive/${r}]: ${e}`;
  o.has(n) || (o.add(n), console.error(n));
}
function s(r, e) {
  console.error(`[naive/${r}]: ${e}`);
}
function t(r, e, n) {
  console.error(`[naive/${r}]: ${e}`, n);
}
function c(r, e) {
  throw new Error(`[naive/${r}]: ${e}`);
}
export {
  t as error,
  c as throwError,
  s as warn,
  a as warnOnce
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/naive/warn.js
// module id = 11
// module chunks = 67